import React, { useState, useEffect } from "react";
import { Col, Row, FormGroup, Input, Button, Label, Table } from "reactstrap";
import Alert from "react-s-alert";
import { api, constant } from "../helpers";

const CurrentInventoryTotals = props => {
  const [warehouseAreas, setWarehouseAreas] = useState([]);
  const [warehouseAreaId, setWarehouseAreaId] = useState(null);
  const [searchTypes, setSearchTypes] = useState([
    constant.inventorySearchType.both,
    constant.inventorySearchType.parts,
    constant.inventorySearchType.products
  ]);
  const [searchType, setSearchType] = useState(
    constant.inventorySearchType.both.id
  );
  const [code, setCode] = useState("");
  const [partialDescription, setPartialDescription] = useState("");
  const [processing, setProcessing] = useState(false);
  const [results, setResults] = useState(null);

  useEffect(() => {
    api
      .fetch("Reference/WarehouseAreas")
      .then(response => {
        setWarehouseAreas(response.data || []);
      })
      .catch(error =>
        Alert.error("There was an error loading the warehouse areas")
      );
  }, []);

  const getSearchCriteria = () => {
    return JSON.stringify({
      InventorySearchType: parseInt(searchType, 10),
      Code: code,
      PartialDescription: partialDescription,
      WarehouseAreaId: warehouseAreaId ? parseInt(warehouseAreaId, 10) : null
    });
  };

  const getResults = () => {
    setProcessing(true);
    api
      .post("Warehouse/CurrentInventoryTotals", getSearchCriteria())
      .then(response => setResults(response.data))
      .catch(() => Alert.error("There was an error exporting report results"))
      .finally(() => setProcessing(false));
  };

  const exportToExcel = () => {
    setProcessing(true);

    api
      .postDownloadBinary(
        "Warehouse/CurrentInventoryTotalsExport",
        getSearchCriteria(),
        constant.mimeTypes.xlsx,
        "CurrentInventoryTotalsExport.xlsx"
      )
      .catch(() => Alert.error("There was an error exporting report results"))
      .finally(() => setProcessing(false));
  };

  return (
    <div className="ml-4 mr-4">
      <Row className="pageTitle p-2">
        <Col>
          <h4 className=""> Current Inventory Totals </h4>
        </Col>
      </Row>
      <Row className="mt-2">
        <Col xs={2}>
          <FormGroup>
            <Label> Inventory Totals Type </Label>
            <select
              value={searchType}
              className="form-control"
              onChange={e => setSearchType(e.target.value)}
            >
              {searchTypes.map((x, index) => (
                <option value={x.id} key={`searchType${index}`}>
                  {x.name}
                </option>
              ))}
            </select>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> Warehouse Area </Label>
            <select
              value={warehouseAreaId}
              onChange={e => setWarehouseAreaId(e.target.value)}
              className="form-control"
            >
              <option value="">All</option>
              {warehouseAreas.map((x, index) => (
                <option value={x.id} key={`warehouseArea${index}`}>
                  {x.name}
                </option>
              ))}
            </select>
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> Code Starts With </Label>
            <Input value={code} onChange={e => setCode(e.target.value)} />
          </FormGroup>
        </Col>
        <Col xs={2}>
          <FormGroup>
            <Label> Description Contains</Label>
            <Input
              value={partialDescription}
              onChange={e => setPartialDescription(e.target.value)}
            />
          </FormGroup>
        </Col>
        <Col xs={1}>
          <Button
            color="primary"
            disabled={processing}
            style={{ marginTop: "2em" }}
            onClick={() => getResults()}
          >
            Search
          </Button>
        </Col>
        {results &&
          results.length !== undefined &&
          results.length > 0 && (
            <Col xs={3}>
              <Button
                disabled={processing}
                style={{ marginTop: "2em", float: "right" }}
                onClick={() => exportToExcel()}
              >
                Export To Excel
              </Button>
            </Col>
          )}
      </Row>
      <Row className="mt-2">
        <Col xs={12}>
          {results &&
            results.length !== undefined &&
            results.length > 0 && (
              <Table>
                <thead>
                  <tr>
                    <th>SKU / Product Number</th>
                    <th>Description</th>
                    <th>Total</th>
                  </tr>
                </thead>
                <tbody>
                  {results.map((x, index) => (
                    <React.Fragment key={`result-${index}`}>
                      <tr style={{ backgroundColor: "#DCDCDC" }}>
                        <td>{x.code}</td>
                        <td>{x.description} </td>
                        <td>{x.grandTotal} </td>
                      </tr>
                      {x.warehouseAreaSubTotals.map((y, yindex) => (
                        <tr key={`result-${index}-subtotal${yindex}`}>
                          <td />
                          <td>{y.warehouseAreaName} </td>
                          <td>{y.subTotal} </td>
                        </tr>
                      ))}
                    </React.Fragment>
                  ))}
                </tbody>
              </Table>
            )}
          {results &&
            results.length !== undefined &&
            results.length === 0 && (
              <p>No results were found with the selected filters</p>
            )}
        </Col>
      </Row>
    </div>
  );
};

export default CurrentInventoryTotals;



// WEBPACK FOOTER //
// ./src/components/CurrentInventoryTotals.js